const video = {

	$window: $(window),

	elem: {
		$body: $('body'),
		$play: $('.play-button')
	},

	init() {
		if (this.elem.$play.length > 0) {
			this.bindSelectors();
			this.bindUIActions();
		}
	},

	bindUIActions() {

		this.elem.$play.magnificPopup({
			type: 'iframe',
			closeMarkup: '<button title="%title" type="button" class="mfp-close btn btn--large">&#215;</button>',
			iframe: {
				patterns: {
					youtube: {
						src: '//www.youtube.com/embed/%id%?autoplay=1&modestbranding=1&rel=0'
					}
				}
			}
		});

	},

	bindSelectors() {

		this.elem.$body = $('body');
		this.elem.$play = $('.play-button');

	}

};

export { video };
